import React, { useState } from "react";

import Button from "components/button";
import { useTranslation } from "i18n";

import DragAndDrop from "../../jobDetails/components/drag&drop-file";

const UploadPassport = ({
  applyFVS,
  loading,
  error,
  onBack,
  passportFile,
  setPassportFile,
}) => {
  const { t } = useTranslation();
  const [img, setImg] = useState(passportFile || "");
  const alreadyScanned = Boolean(img?.name);

  const handleFile = (file) => {
    setImg(file || "");
    setPassportFile?.(file || null);
  };

  return (
    <section className="entry-fee-panel entry-fee-upload">
      <header className="entry-fee-panel__head">
        <p className="entry-fee-kicker">{t("entryFee.steps.uploadPassport")}</p>
        <h2>
          {alreadyScanned
            ? t("entryFee.upload.readyTitle")
            : t("entryFee.upload.title")}
        </h2>
        <p>
          {alreadyScanned
            ? t("entryFee.upload.readyLead")
            : t("entryFee.upload.lead")}
        </p>
      </header>

      {error && <p className="entry-fee-alert">{error}</p>}

      <DragAndDrop
        file={img}
        label={t("entryFee.upload.label")}
        getFile={handleFile}
      />

      <div className="entry-fee-actions">
        <Button
          className="entry-fee-action"
          disabled={!img}
          loading={loading}
          onClick={() => applyFVS(img)}
        >
          {t("entryFee.upload.submit")}
        </Button>
        {onBack && (
          <button type="button" className="entry-fee-back" onClick={onBack}>
            {t("entryFee.form.back")}
          </button>
        )}
      </div>
    </section>
  );
};

export default UploadPassport;
